import "babel-polyfill"
import React from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Menu from '../components/menu'
import MobileMenu from '../components/mobileMenu'
import { CookiesProvider } from 'react-cookie';
import CustomCookieNotice from '../components/custom-cookie-notice'

import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import './animations.css'

class Layout extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {

    const { children, location} = this.props;

    return(

      <div>
        <CookiesProvider>
        { location.pathname !== '/' ? <Menu location={location} /> : null }
        <MobileMenu location={location} />
        {children()}
        <div><CustomCookieNotice location={location} / ></div>
        </CookiesProvider>
      </div>

    )
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js